
export class LOVSectoralMeetingStatusExtension {
}
